var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card card-body mt-2",staticStyle:{"border-radius":"10px"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }